module.exports = __webpack_public_path__ + "static/media/king_cobra.5d95b8fb.png";